import React from 'react'
import useSavedCourses from './SavedCoursesProvider'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '~/lib/ui/dialog'
import { Button } from '~/lib/ui/button'
import { useTranslation } from '~/hooks/useTranslation'

const CompletedCourseDialog = () => {
  const {
    selectedCourse,
    showCompletedCourseDialog,
    toggleCompletedCourseDialog,
  } = useSavedCourses()

  const name = selectedCourse?.name || ''

  const { t } = useTranslation('CompletedCourseDialog')

  const handleAddSkills = () => {
    window.location.href = '/assessments_skills'
  }

  const handleAddSkillsToResume = () => {
    window.location.href = '/resume/builder'
  }

  return (
    <Dialog
      open={showCompletedCourseDialog}
      onOpenChange={toggleCompletedCourseDialog}
    >
      <DialogContent
        className="site-info-dialog max-w-xl font-roboto"
        aria-describedby={undefined}
      >
        <DialogHeader>
          <DialogTitle>{t('title', { name })}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-8 p-4">
          <div className="flex justify-between gap-4">
            <Button onClick={handleAddSkills}>{t('cta_1')}</Button>
            <Button onClick={handleAddSkillsToResume}>{t('cta_2')}</Button>
          </div>
          <Button
            className="self-end"
            variant="outline"
            onClick={toggleCompletedCourseDialog}
          >
            {t('skip')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default CompletedCourseDialog
